import {
  AfterContentInit,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
}                                                                            from '@angular/core';
import {
  ApDynComponentComponent
}                                                                            from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                            from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridEditColumnConfig
}                                                                            from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                            from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridGroupColumnConfig
}                                                                            from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {BehaviorSubject, combineLatest, Observable, of, Subscription}        from 'rxjs';
import {debounceTime, delay, filter, map, skip}                              from 'rxjs/operators';
import {
  CampaignYearStore
}                                                                            from '../../stores/login/campaignyear.store';
import {
  SettingsStore
}                                                                            from '../../stores/base-data/settings.store';
import {
  ApDynGridStatusColumnConfig
}                                                                            from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  LanguageStore
}                                                                            from '../../stores/translation/language.store';
import {
  ApDynGridDetailsGridConfig
}                                                                            from '../../ap-dyngrids/config/details/ap-dyn-grid-details-grid-config';
import {MapViewStore}                                                        from '../../stores/layout/mapview.store';
import {ApElementOxydTypeEnum, ApStatsType, MapViewCurrentMenu, MapViewMode} from '../../ap-interface';
import {
  ApNutrientPlanningComponent
}                                                                            from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning.component';
import {FormStore}                                                           from '../../stores/layout/form.store';
import {
  ApDynGridPagerConfig
}                                                                            from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {FieldStore}                                                          from '../../stores/farm/field.store';
import {
  SoilSampleDateStore
}                                                                            from '../../stores/nutrients/soilsampledate.store';
import {
  CropRotationStore
}                                                                            from '../../stores/farm/crop.rotation.store';
import {
  ApTranslationService
}                                                                            from '../../ap-utils/service/ap-translation.service';
import {GetRoundNumericPipe}                                                 from '../../ap-utils';
import {
  JobsStore
}                                                                            from '../../stores/administration/jobs.store';
import {
  GetPermissionPipe
}                                                                            from '../../ap-permission/pipes/get-permission.pipe';
import {LoginStore}                                                          from '../../stores/login/login.store';
import {RbStore}                                                             from '../../stores/nutrients/rb.store';
import {
  BasicFertilisationSummariesStore
}                                                                            from '../../stores/taskmanagement/basic.fertilisation.summaries.store';
import {
  FertilizerStore
}                                                                            from '../../stores/base-data/fertilizer.store';
import {
  ApNutrientStatisticService
}                                                                            from '../service/ap-nutrient-statistic.service';
import {
  ModalDialogStore
}                                                                            from '../../stores/dialog/modal.dialog.store';
import {
  IModalDialogData
}                                                                            from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  ApDynformsConfigFieldset
}                                                                            from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigTextarea
}                                                                            from '../../ap-dynforms/config/ap-dynforms-config-textarea';
import {
  ApDateService
}                                                                            from '../../ap-core/services/ap-date-service';
import {PagerBuilder}                                                        from './configs/pager-builder';
import {
  ApUtilService
}                                                                            from '../../ap-utils/service/ap-util.service';
import {
  ApIcons
}                                                                            from '../../ap-interface/enums/layout/ap-icons';
import {
  GetElementService
}                                                                            from '../../ap-utils/service/ap-get-element.service';
import {ApPermissions}                                                       from 'invoker-transport';
import {
  StatisticStore
}                                                                            from '../../stores/statistic/statistic.store';
import {
  TranslationStore
}                                                                            from '../../stores/translation/translation.store';
import {APP_CONFIGURATION}                                                   from '../../ap-core/config';
import {
  ApOperationMode
}                                                                            from '../../ap-interface/enums/ap-operation-mode.enum';
import {
  NutrientStore
}                                                                            from '../../stores/nutrients/nutrient.store';
import {
  ApElementType
}                                                                            from '../../ap-interface/enums/ap-elements-type.enum';
import {
  ApNutrientService
}                                                                            from '../../ap-utils/service/ap-nutrient.service';
import {
  ApRoleTypeService
}                                                                            from '../../services/common/ap-role-type.service';
import {
  FertilizerService
}                                                                            from '../../services/data/fertilizer.service';
import {
  ApTooltipContentService
}                                                                            from '../../ap-utils/service/ap-tooltip-content.service';
import {
  BaseFertilizationService
}                                                                            from '../../services/data/base-fertilization.service';
import {
  BaseFertilizationCommonService
}                                                                            from '../service/base-fertilization-common.service';
import {
  INutrientOverviewApplGridData,
  INutrientOverviewGridData,
  LimitsType
}                                                                            from '../types/base-fertilization-overview.types';
import {
  PlanningEntryComponentDataType
}                                                                            from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning-configs/nutrient-planning-types';
import {
  StatisticService
}                                                                            from '../../services/data/statistic.service';
import {
  FieldNutrientDistributionStore
}                                                                            from '../../stores/nutrients/field-nutrient-distributions.store';
import {MapStore}                                                            from '../../stores/map/map.store';
import {
  GetRoundNumericPipeConfig
}                                                                            from '../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import {
  IGridStatus
}                                                                            from '../../ap-interface/interfaces/ap-grid-status.interface';
import {nameOf}                                                              from '../../ap-core/utils/ap-name-of';
import {
  RemainDemandOption
}                                                                            from '../../types/base-fertilization.types';
import IGuid = System.IGuid;
import IField = Data.FieldManagement.IField;
import ICampaignYear = Data.Authentication.ICampaignYear;
import IBasicFertilisationSummaries = Data.TaskManagement.IBasicFertilisationSummaries;

@Component({
  selector: 'ap-nutrient-management-overview',
  template: `
    <ap-dyncomponent [caption]="'Admin_Pages__Overview'"
                     [canSearch]="true"
                     [headerIcon]="'ap-icon-base-fertilization'"
                     [loading$]="loading$"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [details]="details$ | async"
                     [pager]="pager"
                     [canCreate]="isCreateNewAllowed()"
                     (create)="onCreate()">
    </ap-dyncomponent>
  `,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .content-grey-light span {
        color: #c0c0c0;
      }
    `
  ]
})
export class ApNutrientManagementOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public columns$: Observable<ApDynGridColumnConfigBase[]>;
  public details$: Observable<ApDynGridDetailsGridConfig>;
  public loading$: Observable<boolean>;
  public items$: Observable<INutrientOverviewGridData[]> = of([]);
  public pager: ApDynGridPagerConfig;
  public ApPermissions = ApPermissions;

  private _cropRotationLimits$: BehaviorSubject<LimitsType> = new BehaviorSubject<LimitsType>(undefined);
  private _year$ = new BehaviorSubject<number>(undefined);
  private _previousYear = new EventEmitter<void>();
  private _nextYear = new EventEmitter<void>();
  private _onCheckFieldEvent = new EventEmitter<any>();
  private _onNavigateToReportEvent = new EventEmitter<any>();
  private _subscriptions: Subscription[] = [];
  private _isOnCreatePressed = false;

  constructor(private campaignYearStore: CampaignYearStore,
              private cropRotationStore: CropRotationStore,
              private fieldStore: FieldStore,
              private formStore: FormStore,
              private languageStore: LanguageStore,
              private mapViewStore: MapViewStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private settingsStore: SettingsStore,
              private soilSampleDateStore: SoilSampleDateStore,
              private translationService: ApTranslationService,
              private jobsStore: JobsStore,
              private permissionPipe: GetPermissionPipe,
              private loginStore: LoginStore,
              private rbStore: RbStore,
              private fieldNutrientDistributionStore: FieldNutrientDistributionStore,
              private basicFertilisationSummariesStore: BasicFertilisationSummariesStore,
              private fertilizerStore: FertilizerStore,
              private nutrientStatisticService: ApNutrientStatisticService,
              private statisticService: StatisticService,
              private modalDialogStore: ModalDialogStore,
              private dateService: ApDateService,
              private mapStore: MapStore,
              private elementService: GetElementService,
              private statisticStore: StatisticStore,
              private translationStore: TranslationStore,
              private nutrientStore: NutrientStore,
              private nutrientService: ApNutrientService,
              private fertilizerService: FertilizerService,
              private tooltipContentService: ApTooltipContentService,
              private baseFertilizationService: BaseFertilizationService,
              private baseFertilizationCommonService: BaseFertilizationCommonService) {
  }

  public ngOnInit(): void {
    this.fieldStore.changeSelectedField([]);
    this.statisticStore.removeStatisticData();
    this.loading$ = combineLatest([
      this.fieldStore.Listen(s => s.loading),
      this.soilSampleDateStore.Listen(s => s.loading),
      this.cropRotationStore.Listen(s => s.historyLoading),
      this.basicFertilisationSummariesStore.Listen(s => s.loading),
      this.rbStore.Listen(s => s.loading)
    ]).pipe(
      map(([f, s, cr, bfs, rb]) => f || s || cr || bfs || rb)
    );
    this.items$ = this._getItems();
    this.pager = this._getPager();
    this.columns$ = this._getBaseGrid();
    this.details$ = this._getDetailsGrid();
  }

  public ngAfterContentInit(): void {
    const campYear = this.campaignYearStore.getSelectedCampaignYear();
    if (campYear) {
      this._cropRotationLimits$.next({
        Min: campYear.Year,
        Max: campYear.Year
      });
      this._year$.next(campYear.Year);
    }

    this._subscriptions.push(this.dynComponent.SelectedItems$.pipe(
      debounceTime(100),
      delay(1)
    ).subscribe(d => this._selectionChange(d)));
    this._subscriptions.push(this._onCheckFieldEvent.subscribe(e => {
      this._onCheckField(e.Geom.Id);
    }));
    this._subscriptions.push(this._onNavigateToReportEvent.subscribe(e => this._onNavigateToReport({
      fieldGeomId: e.Geom.Id,
      year: this.campaignYearStore.SelectedCampaignYear.Year,
    })));
    this._subscriptions.push(
      this.campaignYearStore.Listen(s => s.selectedYear).pipe(skip(1)).subscribe((y) => this._onSelectedYearChanged(y))
    );
    this._subscriptions.push(
      this.rbStore.Listen(s => s.checkResult).subscribe(checkResult => this._handleRbStoreCheckResult(checkResult))
    );
    this._subscriptions.push(
      this.fieldStore.Listen(s => s.data).subscribe(fields => this._handleFieldStoreData(fields))
    );
    this._subscriptions.push(
      this._previousYear.subscribe(() => this._year$.next(this._year$.value - 1))
    );
    this._subscriptions.push(
      this._nextYear.subscribe(() => this._year$.next(this._year$.value + 1))
    );
    this._subscriptions.push(
      this.mapViewStore.Listen(s => s.currentMenu).subscribe(mapMenu => this._onMapMenuChanged(mapMenu))
    );
    this._subscriptions.push(
      combineLatest([
        this.cropRotationStore.Listen(s => s.history).pipe(
          map((history) => Object.values(history)),
          filter((crops) => crops.length !== 0),
          map((crops) => crops.map((crop) => Object.keys(crop).filter((key) => crop[key] !== null).map((key) => +key))),
          map((years) => years.reduce((a, b) => a.concat(b)))),
        this.campaignYearStore.Listen(s => s.selectedYear)
      ]).pipe(
        map(([dates, campaignYear]): LimitsType => ({
          Min: Math.min(...dates, campaignYear.Year),
          Max: Math.max(...dates, campaignYear.Year)
        }))).subscribe(l => this._cropRotationLimits$.next(l))
    );
    this._subscriptions.push(this.formStore.FormClose$.subscribe(() => {
      // trigger refresh of selection and map after entryComponent (e.g. 'NEW') closed
      if (this._isOnCreatePressed) {
        this._isOnCreatePressed = false;
        this._handleLegendsAndLayers();
      }
    }));
    this._subscriptions.push(this.mapStore.Layers.OnLayerChange.subscribe(() => {
      this._handleLegendsAndLayers();
    }));
    this._handleLegendsAndLayers();
  }

  public ngOnDestroy(): void {
    this.baseFertilizationCommonService.revertLegends();
    this._subscriptions.forEach(s => s?.unsubscribe());
    this.statisticStore.removeStatisticData();
    this.fieldStore.changeSelectedField([]);
  }

  public onCreate(): void {
    this.statisticStore.removeStatisticData();
    this.formStore.openForm({
      component: ApNutrientPlanningComponent,
      data: {
        Summary: null,
        Type: PlanningEntryComponentDataType.Create
      }
    });
    this._isOnCreatePressed = true;
  }

  public isCreateNewAllowed(): boolean {
    return ApRoleTypeService.hasDeveloperRole(this.loginStore.User);
  }

  private _getItems(): Observable<INutrientOverviewGridData[]> {
    return combineLatest([
      this.fieldStore.Listen(s => s.data),
      this.soilSampleDateStore.Listen(s => s.dates),
      this.fieldNutrientDistributionStore.SampleRegions$,
      this.cropRotationStore.Listen(s => s.history),
      this.rbStore.Listen(s => s.rb),
      this.basicFertilisationSummariesStore.Summaries$,
      this.jobsStore.BlockedFieldIdsBuWsvCeIrRbFieldRaster$,
      this.cropRotationStore.Listen(s => s.cropRotationAttributes),
      this.campaignYearStore.SelectedCampaignYear$,
      this.loading$
    ]).pipe(
      filter(([fields, , , cropRotation, rb, , _, _1, selectedCampaignYear, loading]) => {
        return fields.length !== 0 && Object.keys(cropRotation).length !== 0 && !!rb && !!selectedCampaignYear && !loading;
      }),
      map(([fields, soilSampleDates, sampleRegions, cropRotation, rb, bFS, jobFieldGeomIds, cropRotationAttributes, selectedCampaignYear]) => {
        return fields.map<INutrientOverviewGridData>((field) => {
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const cropRotationAttribute = cropRotationAttributes.find(x => x?.FieldGeomId === geom?.Id);
          const area = geom != null && geom.AdminArea > 0 ? geom.AdminArea / 10000 : '-';
          const rbResult = rb.FirstOrDefault(x => x.FieldGeomId === geom?.Id);
          const hasRbRaster = cropRotationAttribute && cropRotationAttribute.HasRbRaster;
          const apps = bFS.filter(_ => !(hasRbRaster && (!rbResult?.PlanIds || rbResult.PlanIds.length <= 0)))
            .filter(summary => summary.BasicFertilisationPlanBooks.Find(x =>
              (rbResult?.PlanIds != null && rbResult.PlanIds.length > 0)
                ? rbResult.PlanIds.includes(x.Id)
                : x.FieldId === field?.Id))
            .map(summary => summary);
          const sampleDateObject = Object.keys(soilSampleDates).length > 0 ? soilSampleDates[field.Id as string] : undefined;
          const status = this.baseFertilizationService.getGDStatusByCrAttribute(sampleDateObject, sampleRegions,
            selectedCampaignYear, cropRotationAttribute);
          let applications: INutrientOverviewApplGridData[] = [];
          if (!!apps || apps !== null) {
            applications = [];
            apps.forEach((summary: IBasicFertilisationSummaries) => {
              const planBook = summary.BasicFertilisationPlanBooks.Find(
                x => (rbResult?.PlanIds != null && rbResult.PlanIds.length > 0)
                  ? rbResult.PlanIds.includes(x.Id)
                  : x.FieldId === field?.Id);
              const fertilizer = this.fertilizerStore.getFertilizer(planBook.Product_Id);
              const unit = summary.User_Appl_Unit?.Id === 1
                ? this.fertilizerService.getFertilizerUnit(fertilizer, true)
                : this.translationService.translate(summary.User_Appl_Unit?.Key);
              const isBooked = planBook?.BookedAt !== null;
              applications.Add({
                Id: planBook.Id,
                Status: this.nutrientService.getFertilizerStatus(summary.User_Appl_Mode, isBooked)?.state,
                StatusClass: this.nutrientService.getFertilizerStatus(summary.User_Appl_Mode, isBooked)?.class,
                StatusDesc: this.nutrientService.getFertilizerStatusDescription(summary.User_Appl_Mode, isBooked),
                IsBooked: isBooked,
                Product: this.fertilizerService.getFertilizerProductName(fertilizer),
                ProductId: planBook.Product_Id,
                ProductUnit: this.fertilizerService.getFertilizerUnit(fertilizer, false),
                ProductTooltip: this.tooltipContentService.getProductContentInfoTooltip(planBook.Product_Id),
                Amount: summary.User_Appl_Rate,
                AmountUnit: unit,
                AmountValue: summary.User_Appl_Rate,
                LeadNutrient: planBook.Element?.Id as ApElementType,
                OutputDate: new Date(planBook.ApplicationDate),
                Nutrient: planBook.Operation_Mode?.Id === ApOperationMode.Const ? '-' : this.elementService.GetElementStringByIElement(planBook.Element),
                Name: summary.Title,
                PlanNumber: summary.PlanNumber,
                CreatedAt: new Date(planBook.CreatedAt),
                Remain2: {
                  P: this.elementService.CalculateElementOxidValueByGivenElementValue(this.nutrientStatisticService.getAverageNutrientFromStatistic(0, planBook.Statistic), ApElementOxydTypeEnum.P),
                  K: this.elementService.CalculateElementOxidValueByGivenElementValue(this.nutrientStatisticService.getAverageNutrientFromStatistic(1, planBook.Statistic), ApElementOxydTypeEnum.K),
                  Mg: this.elementService.CalculateElementOxidValueByGivenElementValue(this.nutrientStatisticService.getAverageNutrientFromStatistic(2, planBook.Statistic), ApElementOxydTypeEnum.Mg),
                  CaO: this.nutrientStatisticService.getAverageNutrientFromStatistic(3, planBook.Statistic),
                  N: this.baseFertilizationService.calculateNElementByLeadElement(planBook.Product_Id, planBook.Statistic)?.Average ?? ''
                },
                Field: field,
                Area: (planBook.Area ?? 0) / 10000,
                SourceItem: summary
              });
            });
          }
          return {
            Id: field.Id,
            Status: status,
            Geom: geom,
            Nr: field.FieldNumber,
            TNr: field.FieldSubnumber,
            NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            Name: field.FieldName,
            Area: area === '-' ? undefined : area,
            AreaOriginal: area === '-' ? undefined : area.toString(10),
            SampleDate: !!sampleDateObject?.Date ? this.dateService.getDateMidnight(sampleDateObject.Date) : undefined,
            ColumnLoading: Object.keys(soilSampleDates).length > 0 && (rb.length === 0 || jobFieldGeomIds.Contains(field.Id.toString())),
            Remain1: this.baseFertilizationService.getRemainDemands(status, rbResult, RemainDemandOption.First),
            Remain2: this.baseFertilizationService.getRemainDemands(status, rbResult, RemainDemandOption.Second),
            Crop: cropRotation[field.Id as string],
            CrNeeds: cropRotationAttribute?.CropRotationNeed,
            Applications: applications,
            SourceItem: field,
          } as INutrientOverviewGridData;
        });
      })
    );
  }

  private _getPager(): ApDynGridPagerConfig {
    const iconOptions = [
      {
        icon: ApIcons.PDF,
        callback: ApUtilService.createEventEmitter(this._onPdf.bind(this), this._subscriptions),
        tooltip: 'Global__Save_PDF'
      },
      {
        icon: ApIcons.XLS,
        callback: ApUtilService.createEventEmitter(this._onXls.bind(this), this._subscriptions),
        tooltip: 'Global__Save_EXCEL'
      }
    ];
    return PagerBuilder.NutrientManagementPager([], iconOptions);
  }

  private _getDetailsGrid(): Observable<ApDynGridDetailsGridConfig> {
    const detailsGridPopupOptions = new ApDynGridEditColumnConfig({
      data: [
        {
          text: 'Global__Show',
          callback: ApUtilService.createEventEmitter(this._onShow.bind(this), this._subscriptions)
        },
        {
          text: 'Global__Export',
          callback: ApUtilService.createEventEmitter(this._onExport.bind(this), this._subscriptions)
        },
        {
          text: 'Admin_Pages_Popups__Book',
          callback: ApUtilService.createEventEmitter(this._onBooking.bind(this), this._subscriptions),
          disabled: (dataItem: INutrientOverviewApplGridData) => dataItem.IsBooked
        },
        {
          text: 'Global__Planing_Reset',
          callback: ApUtilService.createEventEmitter(this._onUnbookBookedPlan.bind(this), this._subscriptions),
          disabled: (dataItem: INutrientOverviewApplGridData) => !dataItem.IsBooked
        },
        {
          text: 'Global__Delete',
          callback: ApUtilService.createEventEmitter(this._onOneDelete.bind(this), this._subscriptions),
          disabled: (dataItem: INutrientOverviewApplGridData) => dataItem.IsBooked
        },
      ]
    });
    if (ApRoleTypeService.hasAgriconRole(this.loginStore.User)) {
      detailsGridPopupOptions.data.push({
        text: 'Global__Download',
        callback: ApUtilService.createEventEmitter(this._onDownloadPackage.bind(this), this._subscriptions)
      });
    }
    return combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data),
    ]).pipe(
      map(([language, settings]) => ({language, setting: settings[0]})),
      filter((p) => !!p.language && !!p.setting),
      map((p) =>
        new ApDynGridDetailsGridConfig({
          field: 'Applications',
          checkboxDisabled: true,
          hide: (dataItem) => dataItem.Applications.length === 0,
          columns: [
            new ApDynGridStatusColumnConfig({
              field: 'Status',
              class: 'StatusClass',
              description: 'StatusDesc'
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Product',
              field: 'Product',
              cssClass: 'left',
              width: 100,
              tooltip: (dataItem) => dataItem['ProductTooltip'],
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Nutrients__FertilizationDate',
              field: 'OutputDate',
              format: p.language.DateFormat,
              tooltip: (dataItem) => `${this.translationStore.FindTranslationForSelectedLanguage('Global__Task')}
                  ${this.translationStore.FindTranslationForSelectedLanguage('Docu_Ini__Number')}:
                  ${dataItem?.PlanNumber}`,
              width: 80
            }),
            new ApDynGridPropertyColumnConfig({
              title: `${this.translationService.translate('Nutrients__Average_Amount_Goods')} / ${this.translationService.translate('Global__Remaining_Need_Two_Short')}`,
              field: 'Amount',
              hide: false,
              width: 60,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              pipes: [
                {
                  pipe: this.roundNumericPipe,
                  args: [0]
                }
              ]
            }),
            new ApDynGridPropertyColumnConfig({
              title: '',
              field: 'AmountUnit',
              width: 40,
              hide: false,
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'AgriConnect__Nutrient',
              field: 'Nutrient',
              hide: true,
              width: 60
            }),
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.P),
              cssClass: 'right', filterType: FilterType.NUMBER,
              field: 'Remain2.P',
              width: 60,
              pipes: [
                {
                  pipe: this.roundNumericPipe,
                  args: [
                    0,
                  ]
                }
              ]
            }),
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.K),
              cssClass: 'right', filterType: FilterType.NUMBER,
              field: 'Remain2.K',
              width: 60,
              pipes: [
                {
                  pipe: this.roundNumericPipe,
                  args: [
                    0,
                  ]
                }
              ]
            }),
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.Mg),
              cssClass: 'right', filterType: FilterType.NUMBER,
              field: 'Remain2.Mg',
              width: 60,
              pipes: [
                {
                  pipe: this.roundNumericPipe,
                  args: [
                    0,
                  ]
                }
              ]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__NutrientCaO',
              field: 'Remain2.CaO',
              cssClass: 'right', filterType: FilterType.NUMBER,
              width: 60,
              pipes: [
                {
                  pipe: this.roundNumericPipe,
                  args: [
                    0,
                  ]
                }
              ]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__NutrientN',
              field: 'Remain2.N',
              cssClass: 'right', filterType: FilterType.NUMBER,
              width: 60,
              hide: true,
              pipes: [
                {
                  pipe: this.roundNumericPipe,
                  args: [
                    0,
                  ]
                }
              ]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Note',
              field: 'Name',
              hide: true,
              cssClass: 'left',
              width: 100
            }),
            detailsGridPopupOptions
          ]
        }))
    );
  }

  private _getBaseGrid(): Observable<ApDynGridColumnConfigBase[]> {
    return combineLatest([
      this._cropRotationLimits$,
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data),
      this.permissionPipe.transform(ApPermissions.EDIT_FIELDS),
      this.loginStore.User$,
    ]).pipe(
      filter(([limits, language, settings, permission, user]) => !!limits && !!language && !!settings[0] && !!permission && !!user),
      map(([limits, language, settings, permission, user]) => ({
        limits,
        language,
        setting: settings[0],
        permission,
        user
      })),
      map((p) => [
        new ApDynGridStatusColumnConfig({
          field: `${nameOf<INutrientOverviewApplGridData>('Status')}.${nameOf<IGridStatus>('state')}`,
          class: `${nameOf<INutrientOverviewApplGridData>('Status')}.${nameOf<IGridStatus>('class')}`,
          description: `${nameOf<INutrientOverviewApplGridData>('Status')}.${nameOf<IGridStatus>('description')}`,
          pending: this.jobsStore.BlockedFieldIdsBuWsvCeIrRbFieldRaster$,
          pendingTooltip: this.jobsStore.BlockedFieldIdsBuWsvCeIrRbFieldRasterTooltip$
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: 'Nr',
          width: 60,
          hide: true,
          headerFilterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini_Subnumber',
          field: 'TNr',
          width: 60,
          hide: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: 'NrTNr',
          width: 75,
          filterable: true,
          headerFilterable: true,
          hide: new ApDynGridColumnHideConfig({
            mapHide: false,
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
          })
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Name',
          field: 'Name',
          headerFilterable: true,
          filterable: true,
          width: 180,
          cssClass: 'left',
          sortIndex: 0,
          sortDesc: false,
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Area',
          field: 'Area',
          hide: true,
          headerFilterable: true,
          tooltip: (dataItem) => dataItem['AreaOriginal'],
          filterType: FilterType.NUMBER,
          width: 60,
          cssClass: 'right',
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [p.setting.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__SampleDate_Short',
          field: 'SampleDate',
          format: p.language.DateFormat,
          hide: true,
          headerFilterable: true,
          filterable: true,
          filterType: FilterType.KENDO_DATE_RANGE,
          width: 80
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Nutrients__Average_RemainingNeed_1_kg_ha',
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.P),
              field: 'Remain1.P',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain1.P === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.K),
              field: 'Remain1.K',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain1.K === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.Mg),
              field: 'Remain1.Mg',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain1.Mg === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Nutrients__CaO',
              field: 'Remain1.CaO',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain1.CaO === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            })
          ],
          hide: true
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Nutrients__Average_RemainingNeed_2_kg_ha',
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.P),
              field: 'Remain2.P',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain2.P === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.K),
              field: 'Remain2.K',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain2.K === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: this.elementService.GetElementStringByString(ApElementType.Mg),
              field: 'Remain2.Mg',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain2.Mg === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Nutrients__CaO',
              field: 'Remain2.CaO',
              width: 60,
              headerFilterable: true,
              columnLoading: 'ColumnLoading',
              cssClass: 'right',
              dynCssClass: (item: INutrientOverviewGridData) => item.Remain2.CaO === 0 ? ' content-grey-light' : '',
              filterType: FilterType.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            })
          ],
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__Crop',
          style: 'text-align:center',
          width: 100,
          headerButtons: {
            nextClicked: this._nextYear,
            nextDisabled: this._year$.pipe(map((y) => y >= p.limits.Max)),
            previousClicked: this._previousYear,
            previousDisabled: this._year$.pipe(map((y) => y <= p.limits.Min)),
          },
          groupColumns: this._getCropRotationConfigs(p.limits),
          hide: new ApDynGridColumnHideConfig({
            widthHidePriority: 1
          })
        }),
        new ApDynGridEditColumnConfig({
            data: (() => {
              const options = [];
              if (ApRoleTypeService.hasAgriconRole(p.user)) {
                options.Add({
                  text: 'Global__Check_Data',
                  callback: this._onCheckFieldEvent,
                });
                options.Add({
                  text: 'Fertilisation__Report',
                  callback: this._onNavigateToReportEvent,
                });
              }
              return options;
            })(),
            disabled: !p.permission,
          }
        )
      ])
    );
  }

  private _onShow(dataItem: INutrientOverviewApplGridData): void {
    this.baseFertilizationCommonService.redirectSummaryToShowView(dataItem.SourceItem.Id, dataItem.IsBooked,
      'nutrients/overview', dataItem.Field.Id);
  }

  private _onExport(dataItem: INutrientOverviewApplGridData): void {
    this.baseFertilizationCommonService.redirectSummaryToExportView(dataItem.SourceItem.Id, dataItem.IsBooked,
      'nutrients/overview', dataItem.Field.Id);
  }

  private _onBooking(dataItem: INutrientOverviewApplGridData): void {
    this.baseFertilizationCommonService.bookPlanBooks(dataItem.SourceItem, dataItem.Field.Id);
  }

  private _onUnbookBookedPlan(dataItem: INutrientOverviewApplGridData): void {
    this.baseFertilizationCommonService.unbookSummaryPlanBook(dataItem.SourceItem, dataItem.Id);
  }

  private _onOneDelete(dataItem: INutrientOverviewApplGridData): void {
    this.baseFertilizationCommonService.deleteSummaryPlanBook(dataItem.SourceItem, dataItem.Id);
  }

  private _onDownloadPackage(dataItem: INutrientOverviewApplGridData): void {
    this.nutrientStore.createNutrientPlanningPackage(dataItem.SourceItem.Id);
  }

  private _onMapMenuChanged(mapMenu: MapViewCurrentMenu): void {
    if (mapMenu === MapViewCurrentMenu.STATS) {
      this._generateStats();
    }
  }

  private _onSelectedYearChanged(campaignYear: ICampaignYear): void {
    if (campaignYear) {
      this.basicFertilisationSummariesStore.loadBasicFertilisationSummaries();
      this._year$.next(campaignYear.Year);
    }
  }

  private _handleRbStoreCheckResult(checkResult: string): void {
    if (checkResult == null || checkResult === '') {
      return;
    }
    const data = {
      buttons: [{
        key: 'apply',
        text: 'Global__Ok',
        primary: true,
      }],
      busy: false,
      show: true,
      title: this.translationService.translate('Global__Result_Check'),
      formConfig: {
        width: 500,
        fieldSets: [
          new ApDynformsConfigFieldset({
            key: 'result',
            legend: 'Global_IO_Values',
            columns: 1,
            useMaxWidth: true,
            config: [
              new ApDynformsConfigTextarea({
                key: 'Output',
                label: 'Global_Output',
                rows: 12,
                value: JSON.stringify(checkResult, null, 2)
              })
            ]
          })]
      }
    } as IModalDialogData;
    this.modalDialogStore.setModalDialogData(data);
  }

  private _handleFieldStoreData(fields: IField[]): void {
    if (fields == null) {
      return;
    }
    if (fields.length === 0) {
      return;
    }
    const tmp = [];
    for (const field of fields) {
      if (!field.FieldGeoms || !Array.isArray(field.FieldGeoms) || field.FieldGeoms.length < 1) {
        continue;
      }
      for (const geom of field.FieldGeoms.filter((g) => g?.Id != null)) {
        // this.rbStore.createRb(geom.Id);
        tmp.push(geom.Id);
      }
    }
    this.rbStore.loadRb(tmp);
  }

  private _selectionChange(items: any[]): void {
    if (items && items.length > 0) {
      const itemsId = items.map(item => item?.Id?.toString());
      this.fieldStore.changeSelectedField(itemsId);
    } else {
      this.fieldStore.changeSelectedField([]);
      this.fieldStore.zoomFarmFields();
    }
    this._handleLegendsAndLayers();
    this._generateStats();
  }

  private _handleLegendsAndLayers(): void {
    const disableLegends = [
      'NutrientPlanningLegend',
      'TaskMgmtLegend'
    ];
    let selectedItems = this.dynComponent?.getSelectedItems()?.length ?? 0;
    if (selectedItems <= 0) {
      // Adding total number of items of grid because component logic works in next way:
      // If there is no data selected, then we should use all data of grid for statistic, maps and legends
      selectedItems = this.dynComponent?.items?.length ?? 0;
    }
    this.baseFertilizationCommonService.handleLegends(selectedItems, disableLegends);
    const disableLayers = [this.mapStore.Layers.TaskManagementLayer?.name];
    this.baseFertilizationCommonService.handleLayers(disableLayers, []);
  }

  private _onNavigateToReport(event: { fieldGeomId: string, year: number }): void {
    window.open(`${APP_CONFIGURATION.MapFactory.Address}/reports/field/${event.fieldGeomId}/${event.year}?key=12345`, '_blank');
  }

  private _onCheckField(fieldGeomId: IGuid): void {
    this.rbStore.checkField(fieldGeomId);
    const data = {
      buttons: [
        {
          key: 'apply',
          text: 'Global__Ok',
          primary: true,
        }
      ],
      busy: true,
      show: true,
      title: this.translationService.translate('Global__Result_Check'),
      formConfig: null,
    } as IModalDialogData;
    this.modalDialogStore.setModalDialogData(data);
  }

  /**
   * build statistic tab if it is visible and selected
   * @private
   */
  private _generateStats(): void {
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.STATS
      || !this.baseFertilizationCommonService.mainComponentSelectionAvailability) {
      return;
    }
    // put it on top of callstack to avoid lagging when the user changes the selection
    setTimeout(() => {
      const emptyTitle = `${this.translationService.translate('Nutrients__StatisticsTitle')}
    ${this.translationService.translate('Global__BasicFertilization')}
    ${this.translationService.translate('Admin_Pages__Overview')}`;
      let items = this.dynComponent.getSelectedItems() as INutrientOverviewGridData[];
      if (!items.Any()) {
        items = this.dynComponent.items as INutrientOverviewGridData[];
      }
      if (!items?.Any()) {
        this.statisticStore.setStatisticData(
          [], ApStatsType.BaseFertStats, '', emptyTitle
        );
        return;
      }
      const title = this._getTitleForStatistic(items);
      this.statisticStore.setStatisticData<INutrientOverviewGridData>(
        items, ApStatsType.BaseFertStats, title, emptyTitle
      );
    }, 100);
  }

  private _getTitleForStatistic(selectedItems: INutrientOverviewGridData[]): string {
    const totalItems = this.dynComponent.items as INutrientOverviewGridData[];
    const dataForTitles = totalItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    return this.statisticService.generateFieldsAreaTitle(dataForTitles);
  }

  private _getCropRotationConfigs(limits: LimitsType): ApDynGridColumnConfigBase[] {
    const columns = [];
    for (let iYear = limits.Min; iYear <= limits.Max + 3; ++iYear) {
      columns.push(new ApDynGridPropertyColumnConfig({
        title: `${iYear}`,
        field: `Crop.${iYear}.MainCropName`,
        filterable: true,
        headerFilterable: iYear === this.campaignYearStore.getSelectedCampaignYear().Year,
        width: 100,
        hide: new ApDynGridColumnHideConfig({
          mapHide: false,
          selfHide: combineLatest([this._year$, this.mapViewStore.Listen(s => s.mode)]).pipe(
            map(([year, mode]) => {
              if (year === iYear) {
                return false;
              }
              return !(mode === MapViewMode.HIDE && iYear > year && iYear < year + 4);
            }),
          ),
        }),
        tooltip: ((dataItem: INutrientOverviewGridData) => this._generateTooltipForCrop(dataItem, iYear))
      }));
    }
    return columns;
  }

  private _generateTooltipForCrop(dataItem: INutrientOverviewGridData, iYear: number): string {
    if (!dataItem || !dataItem.Crop || !dataItem.Crop[iYear]) {
      return '';
    }
    const yearCrop = dataItem.Crop[iYear];
    if (yearCrop.MainCrop === 0 && yearCrop.SecondCrop === 0) {
      return '';
    }
    const br = '<br>';
    const unit = this.translationService.translate('Global__UnitDtPerHa');
    const yieldTranslation = this.translationService.translate('Global__Target');
    let contentMessage = '';
    if (yearCrop.MainCrop !== 0) {
      const mainCropName = `${this.translationService.translate('Nutrients_Pages_Popups__MainCrop')}: ${yearCrop.MainCropName}`;
      contentMessage += `${mainCropName}${br}${yieldTranslation}: ${yearCrop.MainCropYield} ${unit}`;
      if (yearCrop.MainCropStraw) {
        contentMessage += `${br}${this.translationService.translate('Nutrients_Pages__StrawRemoved')}`;
      }
    }
    if (yearCrop.SecondCrop !== 0) {
      const secondCropName = `${this.translationService.translate('Nutrients_Pages_Popups__Intertillage')}: ${yearCrop.SecondCropName}`;
      contentMessage += `${br}${secondCropName}${br}${yieldTranslation}: ${yearCrop.SecondCropYield} ${unit}`;
    }
    const cropsRemoval = this.nutrientService.getRemovalFromCrops(yearCrop);
    const removalPMessage = `${this.elementService.GetElementStringByString(ApElementType.P)}: ${cropsRemoval.RemovalP}`;
    const removalKMessage = `${this.elementService.GetElementStringByString(ApElementType.K)}: ${cropsRemoval.RemovalK}`;
    const removalMgMessage = `${this.elementService.GetElementStringByString(ApElementType.Mg)}: ${cropsRemoval.RemovalMg}`;
    return `${contentMessage}${br}${removalPMessage}${br}${removalKMessage}${br}${removalMgMessage}`;
  }

  private _onXls(): void {
    this.dynComponent.dynGrid.xlsExportFileName = this.generatePrintFilename();
    this.dynComponent.dynGrid.exportAsXls();
  }

  private _onPdf(): void {
    this.dynComponent.dynGrid.pdfExportFileName = this.generatePrintFilename();
    this.dynComponent.dynGrid.exportAsPdf();
  }

  private generatePrintFilename(): string {
    return this.dateService.toFarmDate(new Date()).format('YYYY-MM-DD') + '_' +
      this.translationService.translate('Global__Plannings');
  }
}
